// extracted by mini-css-extract-plugin
export default {"no-search-wrapper":"FFaVJm","noSearchWrapper":"FFaVJm","no-search-icon":"b0_h1o","noSearchIcon":"b0_h1o","no-search-text":"UUxcEo","noSearchText":"UUxcEo"};